import React from 'react';
import './Groups.css';
import Group from './Group/Group';

let Groups = props => (
    <div className="groups-wrapper">
        { 
            props.groups.map((group, index) => (
                    <Group key={group.id}
                           index={index}
                           getLogin={props.getLogin}
                           user={props.user}
                           enterResults={props.enterResults}
                           group={group}/>
                )
            )
        }
    </div>
);

export default Groups;


// WEBPACK FOOTER //
// ./src/components/Groups/Groups.jsx